<template>
  <div>
    <div
      class="filter"
      v-if="displaySlider && !$store.state.view.isLoading"
    >
      <PriceSlider
        :min="0"
        :max="$store.getters.getHighestPrice"
        :name="translations.price"
        v-if="!$store.state.view.isLoading"
        @price-min-changed="updatePriceMin"
        @price-max-changed="updatePriceMax"
      />
    </div>

    <template v-for="attribute in $store.getters.getFilteredAttributeTaxonomies">
      <div
        class="filter"
        v-if="attribute.filter_type === 'slider' && !$store.state.view.isLoading"
        :key="attribute.key"
      >
        <Slider
          :min="Math.min(...attribute.options.map(option => option.slug))"
          :max="Math.max(...attribute.options.map(option => option.slug))"
          :name="attribute.label"
          @min-changed="updateMin"
          @max-changed="updateMax"
        />
      </div>

      <AttributeFilter
        v-if="attribute.filter_type === 'checkbox' || attribute.filter_type === 'select' && !$store.state.view.isLoading"
        :key="attribute.key"
        :attribute="attribute"
        :hasActiveFilters="hasActiveFilters"
      />
    </template>

    <PreviousViews :amountToDisplay="5" />
  </div>
</template>

<script>
import PriceSlider from "@/layouts/general-ui/PriceSlider.vue";
import Slider from "@/layouts/general-ui/Slider.vue";
import AttributeFilter from "@/components/archive/filters/non-hierarchical/Wells.vue";
import PreviousViews from "@/layouts/archive/sidebar/PreviousViews.vue";

export default {
  name: "Filters",
  components: {
    PriceSlider,
    Slider,
    AttributeFilter,
    PreviousViews
  },
  props: {
    hasActiveFilters: Boolean,
  },
  data() {
    return {
      displaySlider: ws_vue_store.archive_price_slider == "1",
      translations: {
        price: ws_vue_store.translations.price,
      }
    };
  },
  methods: {
    updatePriceMin(value) {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('updatePriceFilter', { 'value': value, 'type': 'min' });
    },
    updatePriceMax(value) {
      this.$store.commit('changeProductsLoadingState', true);
      this.$store.commit('updatePriceFilter', { 'value': value, 'type': 'max' });
      this.$store.dispatch("getFilteredAttributes", []).then(() => this.$store.dispatch("getProducts", []));
    },
    updateMin(value) {
      // Handle slider min change
    },
    updateMax(value) {
      // Handle slider max change
    }
  }
};
</script>
